/**
 * IMA-517: dluhopisy v administraci (menu Dluhopisy).
 * Endpointy jsou jen pro ADMIN / SUPERADMIN / BACK_OFFICE, ostatním BE vrací 403.
 */
export default {
    /** Seznam dluhopisů pro vue-good-table (DatatablesTrait). meta.last_export_date = poslední synchronizace s ESO. */
    fetchRecords(body) {
        return new Promise((resolve, reject) => {
            http.post('api/bonds/list', {
                page: body.page,
                search: body.search,
                length: body.pageLength,
                order: [{'column': body.orderColumn, 'dir': body.orderAsc ? 'asc' : 'desc'}],
                filter: body.filter
            }).then(response => {
                resolve(response.data);
            }).catch(() => {
                reject([]);
            });
        });
    },

    getBond(id) {
        return new Promise((resolve, reject) => {
            http.get('api/bonds/' + id).then(response => {
                resolve(response.data);
            }).catch(() => {
                reject([]);
            });
        });
    },

    /** Uloží jen nastavení v aplikaci (aktivace, období prodeje, cílový trh, poplatek); údaje z ESO BE ignoruje. */
    saveSettings(id, data) {
        return new Promise((resolve, reject) => {
            http.post('api/bonds/' + id + '/settings', data).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    },

    // <editor-fold desc="Dokumenty k emisi s verzemi (fáze 4)">
    /** Dokumenty k emisi s aktuální verzí. */
    getDocuments(id) {
        return new Promise((resolve, reject) => {
            http.get('api/bonds/' + id + '/documents').then(response => {
                resolve(response.data);
            }).catch(() => {
                reject([]);
            });
        });
    },

    /** Nový dokument (verze 1): file, name, bond_document_type, attach_to_client. */
    createDocument(id, data) {
        return this._postMultipart('api/bonds/' + id + '/documents', data);
    },

    /** Úprava názvu, typu a volby „přiložit ke klientovi“ (bez souboru). */
    updateDocument(id, documentId, data) {
        return new Promise((resolve, reject) => {
            http.post('api/bonds/' + id + '/documents/' + documentId, data).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    },

    /** Smaže celý dokument včetně všech verzí. */
    deleteDocument(id, documentId) {
        return new Promise((resolve, reject) => {
            http.delete('api/bonds/' + id + '/documents/' + documentId).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    },

    getVersions(id, documentId) {
        return new Promise((resolve, reject) => {
            http.get('api/bonds/' + id + '/documents/' + documentId + '/versions').then(response => {
                resolve(response.data);
            }).catch(() => {
                reject([]);
            });
        });
    },

    /** Nová verze dokumentu; předchozí verze zůstávají v historii. */
    addVersion(id, documentId, file) {
        return this._postMultipart('api/bonds/' + id + '/documents/' + documentId + '/versions', {file});
    },

    /** Smaže jednu verzi (poslední zbývající verzi BE odmítne). */
    deleteVersion(id, documentId, mediaId) {
        return new Promise((resolve, reject) => {
            http.delete('api/bonds/' + id + '/documents/' + documentId + '/versions/' + mediaId).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    },

    /** Odeslání se souborem; boolean se posílá jako 1/0, protože FormData umí jen řetězce. */
    _postMultipart(url, data) {
        const formData = new FormData();
        Object.entries(data).forEach(([key, value]) => {
            formData.append(key, typeof value === 'boolean' ? (value ? '1' : '0') : value);
        });
        return new Promise((resolve, reject) => {
            http.post(url, formData, {headers: {'Content-Type': 'multipart/form-data'}}).then(response => {
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    },
    // </editor-fold>

    /** Klienti, kteří dluhopis vlastní (záložka Klienti). */
    fetchClients(id, body) {
        return new Promise((resolve, reject) => {
            http.post('api/bonds/' + id + '/clients/list', {
                page: body.page,
                length: body.pageLength,
                order: [{'column': body.orderColumn, 'dir': body.orderAsc ? 'asc' : 'desc'}],
            }).then(response => {
                resolve(response.data);
            }).catch(() => {
                reject([]);
            });
        });
    },
}
